import { Route } from '@angular/router';
import { ClientsComponent } from './clients.component';
import { ClientFormComponent } from './client-form/client-form.component';

export const routes: Route[] = [
  {
    path: '',
    component: ClientsComponent,
    data: { title: 'Clients' }
  },
  {
    path: 'form',
    component: ClientFormComponent,
    data: { title: 'Client Form' }
  },
  {
    path: 'edit/:id',
    component: ClientFormComponent,
    data: { title: 'Edit Client' }
  }
];
